import axios, { AxiosInstance } from 'axios';

export const getPortalService = (portalUrl: string): AxiosInstance => {
    return axios.create({
        baseURL: portalUrl,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        withCredentials: true
    });
};
